import { useEffect, useState } from "react";
import Books from "./components/Books";
import Reader from "./components/Reader";
import Watermark from "./components/Watermark";
import Dashboard from "./components/Dashboard";

// 👉 BOOK CONFIGURATION MAP
const BOOK_CONFIG = {
  "ai-book": {
    title: "Artificial Intelligence Foundation - The Stepping Stone",
    totalChapters: 11,
  },
  "u2u-internship-guide": {
    title: "U2U Internship Reference Guide",
    totalChapters: 1,
  },
  "u2u-cyber-labs": {
    title: "U2U Cybersecurity Labs Reference Book",
    totalChapters: 1,
  },
  "u2u-ai-labs": {
    title: "U2U Artificial Intelligence Labs Reference Book",
    totalChapters: 1,
  },
   "u2u-ai-book2": {
    title: "Artificial Intelligence and Machine Learning Made Simple",
    totalChapters: 6,
  },
   "u2u-ai-book3": {
    title: "Build Artificial Intelligence Model in Simple Steps using Scikit Learn",
    totalChapters: 6,
  },
  
   "u2u-ai-book4": {
    title: "Artificial Intelligence Simplified for everyone",
    totalChapters: 10,
  },
  "u2u-ai-book5": {
    title: "Building Artificial Intelligence Models with PyTorch - A Practical Step by Step Guide",
    totalChapters: 4,
  },
  "u2u-ai-book6": {
    title: "100 Artificial Intelligence Concepts Everyone Must Know",
    totalChapters: 3,
  },
  "u2u-ai-book7": {
    title: "Building Artificial Intelligence Applications For The Real World",
    totalChapters: 4,
  },
  "u2u-cyberlabs-practical": {
    title: "Cybersecurity Labs - Building Practical Cybersecurity Skills",
    totalChapters: 4,
  },
  "u2u-cybersmart": {
    title: "Cybersmart A Practical Guide to Digital Safety",
    totalChapters: 5,
  },
  "u2u-cyber-essentials": {
    title: "U2U Cyber Security Essentials",
    totalChapters: 8,
  },
};

function App() {
  const [book, setBook] = useState(null);
  const [chapter, setChapter] = useState(null);

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    document.onkeydown = (e) => {
      if (e.ctrlKey && ["c", "s", "u"].includes(e.key)) {
        e.preventDefault();
      }
    };
  }, []);

  // 👉 Book selection
  const selectBook = (b) => {
    setBook(b);
    setChapter(null);
  };

  // 👉 Chapter selection
  const openChapter = (ch) => {
    setChapter(ch);
  };

  // 👉 Back handlers
  const backToBooks = () => {
    setBook(null);
    setChapter(null);
  };

  const backToChapters = () => {
    setChapter(null);
  };

  // ✅ SAFE fallback (prevents undefined crash)
  const currentBook = BOOK_CONFIG[book] || {
    title: "Unknown Book",
    totalChapters: 0,
  };

  return (
    <div>
      <h1>📚 U2U Book Reading Platform</h1>

      {/* =========================
          1️⃣ BOOK SELECTION VIEW
         ========================= */}
      {book === null ? (
        <Books onSelectBook={selectBook} />
      ) : chapter === null ? (
        /* =========================
            2️⃣ DASHBOARD VIEW
           ========================= */
        <Dashboard
          bookId={book}
          bookTitle={currentBook.title}
          totalChapters={currentBook.totalChapters}
          onOpenChapter={openChapter}
          onBack={backToBooks}
        />
      ) : (
        /* =========================
            3️⃣ READER VIEW
           ========================= */
        <>
          <div style={{ marginBottom: "10px" }}>
            <button onClick={backToChapters}>⬅ Chapters</button>

            <button
              onClick={backToBooks}
              style={{ marginLeft: "10px" }}
            >
              📚 Books
            </button>

            <span style={{ margin: "0 10px" }}>
              Book: {currentBook.title} | Chapter {chapter}
            </span>
          </div>

          <Reader chapter={chapter} book={book} />
        </>
      )}

      <Watermark />
    </div>
  );
}

export default App;